import { StoryboardFunctionRegistryFactory } from "../../StoryboardFunctionRegistry.js";
import { getV2RuntimeFromDll } from "../../getV2RuntimeFromDll.js";
const widgetFunctionRegistry = new Map();
export const widgetFunctions = new Proxy(Object.freeze({}), {
  get(target, key) {
    return widgetFunctionRegistry.get(key);
  }
});
function registerWidgetFunctionsV3(widgetId, functions, widgetVersion) {
  if (widgetFunctionRegistry.has(widgetId)) {
    throw new Error(`Widget functions of "${widgetId}" already registered`);
  }
  const {
    storyboardFunctions,
    registerStoryboardFunctions
  } = StoryboardFunctionRegistryFactory({
    widgetId,
    widgetVersion
  });
  widgetFunctionRegistry.set(widgetId, storyboardFunctions);
  registerStoryboardFunctions(functions);
}

// istanbul ignore next
function registerWidgetFunctionsV2Factory() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return function (widgetId, functions, widgetVersion) {
      return v2Kit.getRuntime().registerWidgetFunctions(widgetId, functions, widgetVersion);
    };
  }
}

// istanbul ignore next
export const registerWidgetFunctions = registerWidgetFunctionsV2Factory() || registerWidgetFunctionsV3;
//# sourceMappingURL=WidgetFunctions.js.map